// frontend/src/components/Layout/PublicLayout.tsx
import React from 'react';
import BaseLayout from './BaseLayout';
import { publicLayoutConfig } from './configs/layoutConfigs';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <BaseLayout config={publicLayoutConfig}>
      {children}
    </BaseLayout>
  );
};

export default PublicLayout;